// src/pages/categories/CategoriesPage.js

import React, { useMemo } from 'react';
import GenericListPage from '../GenericListPage';
import CategoryForm from './CategoryForm';

const categoryColumns = [
  { header: 'ID', key: '_id', render: (category) => category._id.substring(0, 8) + '...' },
  { header: 'Category Name', key: 'name' },
  { header: 'Parent Category', key: 'parentCategoryName', render: (category) => category.parentCategoryName || 'N/A' }, // Display parent category name
  { header: 'Description', key: 'description' },
];

const CategoriesPage = () => {
  const categoryFilterConfig = useMemo(() => [
    {
      name: 'name',
      type: 'text',
      label: 'Name',
    },
    {
      name: 'parentCategoryId', // Allow filtering by parent category
      type: 'select',
      label: 'Parent Category',
      endpoint: 'categories', // Fetch categories for the filter dropdown itself
      keyField: '_id',
      valueField: 'name',
    },
  ], []);

  return (
    <GenericListPage
      title="Categories"
      permission="manage_categories"
      entityEndpoint="categories"
      columns={categoryColumns}
      FormComponent={CategoryForm}
      filterConfig={categoryFilterConfig}
    />
  );
};

export default CategoriesPage;
